
    import '/opt/buildhome/repo/packages/x/components/suggestion/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["suggestion-demo-basic","suggestion-demo-block","suggestion-demo-trigger","suggestion-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/suggestion/index.zh-CN.md?type=demo')
};